const ShareIcon = ({width, height}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    width={width}
    height={height}
    role="img"
    aria-label={"share icon"}
  >
    <path
      stroke={"#27509B"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-11 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm11 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM9 13l6 4m0-10-6 4"
    />
  </svg>
);
export default ShareIcon;
